import { Injectable } from '@angular/core';
import * as socketIo from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs';
import { environment } from "@env/environment";
 const SERVER_URL = environment.SERVER_URL;
@Injectable()
export class WebSocketService {
  observer: Observer<number>
  private socket;
  constructor() {
    this.socket = socketIo(SERVER_URL,{
      "transports": ['websocket']
    });    
  }
  userData = JSON.parse(window.localStorage.getItem('userDetails'))
  // connectSocket(){
  //   this.socket = socketIo(SERVER_URL)
  // }
  public initSocket(): void {
    this.socket = socketIo(SERVER_URL);

  }
  initializeSocket(userId, roleId, token) {
    this.socket.emit('join', { userId: userId, token: token });
    this.socket.emit('join', { roleId: roleId, token: token });
  }
  updateuserBasedNotificationCount(): Observable<number> {
    // if (!this.socket) {
    //   this.connectSocket();
    // }
    this.socket.on('userBasedNotificationCount', (data) => {
      this.observer.next(data['newNotification']);
    });
    return this.createObservable();

  }
  createObservable(): Observable<number> {
    return new Observable(observer => {
      this.observer = observer;
    });
  }
  updateroleBasedNotificationCount() {
    // if (!this.socket) {
    //   this.connectSocket();
    // }
    this.socket.on('roleBasedNotificationCount', (data) => {
      this.observer.next(data['newNotification']);
    });
    return this.createObservable();
  }



}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/web-socket.service.ts